/*jshint globalstrict: false*/

import Vue from 'vue';
import Questionnaire from '../components/workplace/questionnaire';
import CoffeeCardList from '../components/workplace/coffee-card-list';
import Modal from '../components/workplace/modal-workplace';
import axios from 'axios';

Vue.component('questionnaire', Questionnaire);
Vue.component('coffee-card-list', CoffeeCardList);
Vue.component('modal', Modal);

document.addEventListener('DOMContentLoaded', () => {
    Vue.use({
        install (Vue) {
            const csrfToken = document.querySelector("meta[name=csrf-token]").content;
            axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

            Vue.prototype.$accountsApi = axios.create({
                baseURL: '/v1/workplace/accounts/'
            });

            Vue.prototype.$coffeesApi = axios.create({
                baseURL: '/v1/workplace/coffees/'
            });
        }
    });

    new Vue({
        el: '[data-behavior="questionnaire-vue"]',
    });
});
